import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Flex, Heading, VStack, HStack, Text, Badge, IconButton, Spinner,
} from '@chakra-ui/react';
import { FiRefreshCw, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';

export default function HealthCheck() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('meet_token');
  const headers = { 'Authorization': `Token ${token}` };

  const fetchHealth = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/v1/health', { headers });
      if (res.ok) setHealth(await res.json());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchHealth(); }, [fetchHealth]);

  const StatusRow = ({ label, value }) => (
    <Flex justify="space-between" align="center" py={3} borderBottom="1px solid" borderColor="gray.100">
      <Text fontWeight="500" color="gray.700">{label}</Text>
      <HStack>
        {value === 'connected' || value === 'ok' ? (
          <><FiCheckCircle color="#38A169" /><Badge colorScheme="green">{value}</Badge></>
        ) : (
          <><FiAlertCircle color="#E53E3E" /><Badge colorScheme="red">{value}</Badge></>
        )}
      </HStack>
    </Flex>
  );

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Heading size="lg" color="gray.700">System Health</Heading>
        <IconButton icon={<FiRefreshCw />} onClick={fetchHealth} variant="ghost" aria-label="Refresh" />
      </Flex>

      {loading ? (
        <Flex justify="center" py={12}><Spinner size="lg" color="teal.500" /></Flex>
      ) : health ? (
        <Box bg="white" borderRadius="xl" boxShadow="sm" p={6} maxW="500px">
          <VStack align="stretch" spacing={0}>
            <StatusRow label="Service Status" value={health.status} />
            <StatusRow label="Database" value={health.database} />
          </VStack>
        </Box>
      ) : (
        <Text color="gray.400">Unable to fetch health status</Text>
      )}
    </Box>
  );
}
